import { ListFilters, listFilterQuery } from "../types/listFilters";
import apiClient from "./apiClient";
import { Order, OrdersApiResponse } from "../types/order";
import { toLegacyListResponse } from "../utils/normalizePaginatedResponse";

/**
 * Amazon orders are backed by the `Cart` table (Amazon ASIN-based carts).
 * Endpoint group: /api/v1/admins/carts
 */
const CARTS_PATH = "carts";

export const getCarts = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
  filters: ListFilters = {}
): Promise<OrdersApiResponse> => {
  try {
    const params: Record<string, string | number | boolean> = { page, limit, ...listFilterQuery(filters, ["startDate", "endDate", "userId"]) };
    if (search) params.search = search;
    if (status) params.status = status;

    const response = await apiClient.get(CARTS_PATH, { params });
    return toLegacyListResponse<Order, "allOrders">(response.data, "allOrders");
  } catch (error) {

    throw error;
  }
};

/** findOne returns the cart object directly (not wrapped). */
export const getCartById = async (cartId: string): Promise<any> => {
  try {
    const response = await apiClient.get(`${CARTS_PATH}/${cartId}`);
    return response.data;
  } catch (error) {

    throw error;
  }
};

/** Update cart status: PATCH /carts/{id}/status { status }. */
export const updateCartStatus = async (
  cartId: string,
  status: string
): Promise<void> => {
  try {
    await apiClient.patch(`${CARTS_PATH}/${cartId}/status`, { status });
  } catch (error) {

    throw error;
  }
};
